import axios, { AxiosError } from "axios";
import { InsightService } from "@pepper/insights-react";

export const onResponseError = async (
    error: AxiosError
  ): Promise<AxiosError> => {
    const config = error.config;
    
    InsightService.logException(error);

    let counter = 0;
    let maxRetries = 0;
    if (error.response?.status === 500 || error.response?.status === 409){
        if (error.response?.status === 500) {
            maxRetries = 1;
          } else {
            maxRetries = 4;
          }
          while (counter < maxRetries) {
            counter++;
            try {
              const response = await axios.request(config);
              return Promise.resolve(response.data.data);
            } catch (error) {
              if (counter === maxRetries) {
                console.log('Límite de reintentos alcanzado: ', error);
              }
            }
          }
    }

    return Promise.reject(error);
};